import React, { Component } from "react";

import "./ListScroll.css";

class ListScroll extends Component {
    constructor(props) {
        super(props);
        this.listRef = React.createRef();
    }
    componentDidMount() {
        const list = this.listRef.current;
        this.itemWidth = Array.from(list.children)[1].clientWidth;
        this.setState({
            hide_left_ind: list.scrollWidth == list.clientWidth,
        });
    }
    state = {
        hide_left_ind: false,
        hide_right_ind: true,
    };
    render() {
        let { items, Component: Comp, key } = this.props;
        let { hide_left_ind, hide_right_ind } = this.state;

        return (
            <div className='ListScrollComponent'>
                <div
                    className='list'
                    ref={this.listRef}
                    onScroll={(ev) => {
                        
                        if (
                            -1 * ev.target.scrollLeft >=
                            ev.target.scrollWidth - ev.target.clientWidth - 5
                        ) {
                            this.setState({ hide_left_ind: true });
                        } else {
                            this.setState({ hide_left_ind: false });
                        }
                        if (ev.target.scrollLeft > -10) {
                            this.setState({ hide_right_ind: true });
                        } else {
                            this.setState({ hide_right_ind: false });
                        }
                    }}
                >
                    <div
                        className={`scroll right ${
                            hide_right_ind ? "hide" : ""
                        }`}
                        onClick={(ev) => {
                            this.listRef.current.scrollLeft =
                                this.listRef.current.scrollLeft +
                                2 * this.itemWidth;
                        }}
                    >
                        <i className='ri-arrow-right-circle-fill'></i>
                    </div>
                    {items &&
                        items.length > 0 &&
                        items.map((item) => {
                            return <Comp item={item} key={item[key]} />;
                        })}

                    <div
                        className={`scroll left ${hide_left_ind ? "hide" : ""}`}
                        onClick={(ev) => {
                            this.listRef.current.scrollLeft =
                                this.listRef.current.scrollLeft -
                                2 * this.itemWidth;
                        }}
                    >
                        <i className='ri-arrow-left-circle-fill'></i>
                    </div>
                </div>
            </div>
        );
    }
}

export default ListScroll;
